/* eslint-disable */

/**
 * Object().assign() polyfill for IE11
 */
if (typeof Object.assign != 'function') {
  (function () {
    Object.assign = function (target) {
      'use strict';
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      const output = Object(target);
      for (let index = 1; index < arguments.length; index++) {
        const source = arguments[index];
        if (source !== undefined && source !== null) {
          for (let nextKey in source) {
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey];
            }
          }
        }
      }
      return output;
    };
  })();
}

/**
 * Array().fill polyfill for IE11
 */
if (!Array.prototype.fill) {
  Array.prototype.fill = function(value) {
    // Steps 1-2.
    if (this === null) {
      throw new TypeError('this is null or not defined');
    }

    const O = Object(this);

    // Steps 3-5.
    const len = O.length >>> 0;

    // Steps 6-7.
    const start = arguments[1];
    const relativeStart = start >> 0;

    // Step 8.
    let k = relativeStart < 0 ?
      Math.max(len + relativeStart, 0) :
      Math.min(relativeStart, len);

    // Steps 9-10.
    const end = arguments[2];
    const relativeEnd = end === undefined ?
      len : end >> 0;

    // Step 11.
    const final = relativeEnd < 0 ?
      Math.max(len + relativeEnd, 0) :
      Math.min(relativeEnd, len);

    // Step 12.
    while (k < final) {
      O[k] = value;
      k++;
    }

    // Step 13.
    return O;
  };
}



// WEBPACK FOOTER //
// ./app/ie11Polyfills.js